import { DOCUMENT_SEARCH_MIN_QUERY_LENGTH } from '@/constant/documents';

export type GlobalSearchFilterId =
  | 'all'
  | 'jobs'
  | 'contacts'
  | 'parts'
  | 'invoices'
  | 'knowledge'
  | 'sales'
  | 'integrations';

export interface GlobalSearchFilter {
  id: GlobalSearchFilterId;
  label: string;
  /** Comma-separated FSI types; undefined means omit `types`. */
  types?: string;
  /** Filters without a backend yet — hidden until they work. */
  isPlaceholder?: boolean;
  /** Characters before this filter searches. Defaults to 2. */
  minQueryLength?: number;
}

export const GLOBAL_SEARCH_FILTERS: GlobalSearchFilter[] = [
  { id: 'all', label: 'Search for all' },
  { id: 'jobs', label: 'Jobs', types: 'job' },
  { id: 'contacts', label: 'Contacts', types: 'contact,person' },
  { id: 'parts', label: 'Parts' },
  { id: 'invoices', label: 'Invoices', isPlaceholder: true },
  {
    id: 'knowledge',
    label: 'Knowledge base',
    minQueryLength: DOCUMENT_SEARCH_MIN_QUERY_LENGTH,
  },
  { id: 'sales', label: 'Sales performance', isPlaceholder: true },
  { id: 'integrations', label: 'Integrations', isPlaceholder: true },
];
